import { Component, inject, Renderer2, Inject, DOCUMENT } from '@angular/core';

import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { MyMonitoringService } from './services/logging.service';
import { ClientConfigService } from './services/client-config.service';
import { NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MaintenancePageComponent } from './components/maintenance-page/maintenance-page.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    imports: [NgIf, RouterOutlet, MaintenancePageComponent]
})
export class AppComponent {
   title = 'Chill Onboarding';
   isMaintenanceMode = environment.maintenanceMode;

  constructor(
    private monitoringService: MyMonitoringService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private clientConfigService: ClientConfigService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    console.log(`v${environment.appVersion}`)
    this.matIconRegistry.addSvgIcon(
      'UploadaDocument',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/images/UploadaDocument.svg'
      )
    );
  
  }
  ngOnInit() {
    debugger
    this.monitoringService.logTrace('### Log Trace - ONBOARDING ###')
  
    console.log(environment.env);
  }
}
